<ion-header>
  <ion-toolbar mode="ios">
    <ion-button (click)="close()" fill="clear" color="primary" class="ion-no-padding">
      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
    </ion-button>
    <ion-title class="ion-no-padding">
      <ion-img [src]="dataServ.rData.dark_logo" *ngIf="dataServ.rData.dark_logo[0]"></ion-img>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-text color="primary">
          <h1>
            <b>{{ "Bonus History" | translate }}</b>
          </h1>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-list>
          <ng-container *ngFor="let ledger of history">
            <ion-item>
              <!-- <ion-text
                [color]="ledger.point > 0 ? 'success' : 'danger'"
                slot="start"
              >
                {{ ledger.amount
                }}{{
                  ledger.currency_code === "EUR"
                    ? "€"
                    : ledger.currency_code === "USD"
                    ? "$"
                    : ledger.currency_code === "GBP"
                    ? "£"
                    : "TL"
                }}
              </ion-text> -->

              <ion-label text-wrap>
                <ng-container *ngIf="ledger.menu_item_name">
                  {{ ledger.menu_item_name | caption }} <br />
                </ng-container>
                <small>
                  {{ ledger.posting_date | date: "dd/MM/yyyy HH:mm" }}
                </small>
              </ion-label>


              <ion-text [color]="ledger.point > 0 ? 'success' : 'danger'" slot="end">
                <span *ngIf="ledger.point > 0">+</span>{{ 'Points' | translate:{point: ledger.point} }}
              </ion-text>
            </ion-item>
          </ng-container>
        </ion-list>
      </ion-col>
    </ion-row>

    <div class="watermark">
      <img src="assets/img/logo-outline.svg" alt="CVK Park Bosphorus">
    </div>
  </ion-grid>
</ion-content>